/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import styled               from 'styled-components';
import { transparentize }   from 'polished';
import { Colours, Spacing } from '../../../styles/variables';
import { Media }            from '../../../styles/utilities';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const StyledHeader = styled.header`
  padding: ${Spacing.Small};
  display: flex;
  align-items: center;
  background: ${props => props.theme.TabletBackground || Colours.White};
  color: ${props => (props.theme.TabletBackground) ? Colours.White : Colours.Tundora };
  position: ${props => props.theme.TabletPosition || 'static'};
  flex: none;
  width: 100%;
  ${Media.Tablet`
    box-shadow: ${props => (props.theme.TabletBackground) ? 'none' : `0 1px 1px 0 ${transparentize(0.7, Colours.Tundora)}`};
  `}
`;



// WEBPACK FOOTER //
// ./src/components/atoms/StyledHeader/index.js